import { render } from "./Downloads.vue?vue&type=template&id=91e60040&scoped=true"
import script from "./Downloads.vue?vue&type=script&lang=js"
export * from "./Downloads.vue?vue&type=script&lang=js"

import "./Downloads.vue?vue&type=style&index=0&id=91e60040&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91e60040"]])

export default __exports__